import { gql } from 'graphql-tag';
import { GET_STUDENTS_BASE } from './getStudentsBase';
import type { IGetNonDigitalStudentsRosterData } from '../types';

export const GET_NON_DIGITAL_STUDENTS_ROSTER = GET_STUDENTS_BASE<IGetNonDigitalStudentsRosterData>({
  student: gql`
    fragment Student on StudentType {
      id
      absent
      accommodationsArray {
        code
        supplementalInfo
      }
      adultTestTakerFlag
      candDOB
      candFirstName
      candGender
      candLastName
      candMidInit
      candRegNo
      checkedInCenter
      checkedInRoom
      deniedEntry
      groupType
      multiDayInd
      room {
        id
        groupTypes
        title
      }
      updated
      waitListFlag
    }
  `,
});
